import React from 'react';
import { steps } from '../data/ymparistooppi';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-175" data-mp="7slqf02ly3s4">
      <div className="mx-auto max-w-6xl" data-id="element-176" data-mp="3pz018q5kxxma">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-177" data-mp="3q02siz6te22q">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-178" data-mp="3tzbkpzm7hrw6">
            Näin <em className="text-red-700" style={{
            hyphens: 'manual'
          }} data-id="element-179" data-mp="lktjohuoncm2">YMPÄRISTÖOPPI VALMIS™</em> toimii
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-180" data-mp="qlh7kunm7dc2">
            Latauksesta luokkaan: valmistele seuraava tunti vain viidessä minuutissa.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-181" data-mp="grqjhqveh4ww">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-182" data-mp="14hb6qlyl6obz" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-183" data-mp="19byxyskz5wu9">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-184" data-mp="2mncp75hs6ih8">
                <span className="sr-only" data-id="element-185" data-mp="31bzf2151asmp">Vaihe {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-186" data-mp="2wkhg1imkn24d">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-187" data-mp="3aaukvc4620ph">
          Avaa → valitse → valmistaudu → opeta. Helppoa ja selkeää.
        </p>
      </div>
    </section>;
}